export default "__VITE_ASSET__CMmh97ka__"